import React, { useEffect } from 'react'
import Navbar from './global-components/navbar'
import PageHeader from './global-components/page-header'
import FaqSection from './section-components/faq'
import Footer from './global-components/footer'
import Swal from 'sweetalert2'
import useFetch from '../Hooks/useFetch'
import { CircularProgress } from '@material-ui/core'

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { data } = useFetch()
  const myField = data?.items.find((item, index) => {
    if (item.sys.id === '7jVw6QbH2Jdna2Qx4gH1li') {
      return item
    }
  })

  // console.log(myField?.fields)

  const [loading, setloading] = React.useState(false)

  const handleSendEmail = (e) => {
    setloading(true)
    try {
      setTimeout(() => {
        setloading(false)
        Swal.fire(
          'Email Sent!',
          'Your email is sent with your detail',
          'success'
        )
      }, 2000)
    } catch (err) {
      console.error(err)
      setloading(false)
    }
  }

  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle='Contact Us'
        Imagefile={myField?.fields.phTitle.fields.file.url}
      />
      <div
        className='contact-area '
        style={{ paddingTop: '50px', paddingBottom: '20vh' }}
      >
        <div className='container'>
          <div className='text-center mb-5'>
            <h2>{myField?.fields.heading}</h2>
          </div>
          <div className='row'>
            <div className='col-lg-6'>
              <div>
                <h3>{myField?.fields.cc1title}</h3>
                <div>
                  <p className='font-weight-bold'>Head Office:</p>
                  <p>{myField?.fields.cc1headoffice}</p>
                </div>
                <div>
                  <p className='font-weight-bold'>Office Phone No:</p>
                  <p>
                    <a className='text-primary' href='tel:05154001755'>
                      {myField?.fields.cc1phone}
                    </a>
                  </p>
                </div>
                <div>
                  <p className='font-weight-bold'>UAN:</p>
                  <p>
                    <a className='text-primary' href='tel:03115555523'>
                      {myField?.fields.cc1uan}
                    </a>
                  </p>
                </div>
                <div>
                  <p className='font-weight-bold'>Email:</p>
                  <p>
                    <a className='text-primary' href='mailto:info@azca.pk'>
                      {myField?.fields.cc1email}
                    </a>
                  </p>
                </div>

                {/* 
                <div>
                  <p className="font-weight-bold">See our platform in action</p>
                  <p>
                    Request a personalized demo, or sign up for a{" "}
                    <a className="text-primary" href="#">
                      30-day free trial
                    </a>{" "}
                    of TUNE's performace marketing platform
                  </p>
                </div>
                <div>
                  <p className="font-weight-bold">
                    Mastering performance marketing
                  </p>
                  <p>
                    From <a href="#">TUNE Academy cources</a> to industry{" "}
                    <a href="#" className="text-primary">
                      research
                    </a>{" "}
                    and{" "}
                    <a href="#" className="text-primary">
                      insights
                    </a>
                    , learn platform
                  </p>
                </div> */}
              </div>

              <div className='contact-page-map'>
                <iframe
                  src={myField?.fields.cc1map}
                  //   width="600"
                  //   height="450"
                  className='w-100'
                  style={{ border: 0 }}
                  allowfullscreen=''
                  loading='lazy'
                ></iframe>
              </div>
            </div>
            <div className='col-lg-6'>
              <form
                className='contact-form-wrap contact-form-bg'
                style={{ boxShadow: 'none' }}
              >
                <h4 className='text-center my-4'>
                  {myField?.fields.cc2title1}
                </h4>
                <div className='rld-single-input'>
                  <select
                    type='text'
                    className='select-style'
                    placeholder='PURCHASED A PROPERTY'
                  >
                    <option value='Purchase A property'>
                      Purchase A property
                    </option>
                    <option value='Sale a Property'>Sale a Property</option>
                    <option value='Projects'>Projects</option>
                    <option value='Construction'>Construction</option>
                    <option value='Consultancy'>Consultancy</option>
                    <option value='Assessment'>Assessment</option>
                    <option value='Investment Plan'>Investment Plan</option>
                    <option value='About Company'>About Company</option>
                    <option value='Career'>Career </option>
                  </select>
                </div>
                <hr />
                <h4 className='text-center my-4'>{myField?.fields.cc2title}</h4>

                <div className='rld-single-input'>
                  <input type='text' placeholder='FULL NAME' />
                </div>
                <div className='rld-single-input'>
                  <input type='email' placeholder='EMAIL' />
                </div>
                <div className='row'>
                  <div className='col-lg-4'>
                    <div className='rld-single-input'>
                      <input type='number ' placeholder='+92' />
                    </div>
                  </div>
                  <div className='col-lg-8'>
                    <div className='rld-single-input'>
                      <input type='number' placeholder='MOBILE PHONE' />
                    </div>
                  </div>
                </div>
                <hr />
                <h4 className='text-center my-4'>MESSAGE</h4>

                <div className='rld-single-input'>
                  <textarea rows={20} placeholder='Message' defaultValue={''} />
                </div>
                {loading ? (
                  <div className='d-flex justify-content-center mt-2'>
                    <CircularProgress />
                  </div>
                ) : (
                  <div className='btn-wrap text-right'>
                    <button
                      onClick={(e) => handleSendEmail(e)}
                      className='btn btn-yellow'
                    >
                      Submit
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>

          {/* <div className="row pd-top-92">
            <div className="col-xl-3 col-sm-6">
              <div className="single-contact-info">
                <p>
                  <i className="fa fa-phone" />
                  Call Us:
                </p>
                <h5>051-5400175-6</h5>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="single-contact-info">
                <p>
                  <i className="fa fa-fax" />
                  Fax:
                </p>
                <h5>051-5400175-6</h5>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="single-contact-info">
                <p>
                  <i className="fa fa-envelope" />
                  Have any Question?
                </p>
                <h5>azcapk@gmail.com</h5>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="single-contact-info">
                <p>
                  <i className="fa fa-phone" />
                  Address
                </p>
                <h5>
                  AZCA Sales 1ST FLOOR, SADAAT BUSINESS CENTRE, MINI COMMERCIAL
                </h5>
                <h5>Office: EXTENSION II, BAHRIA TOWN PHASE VII, RAWALPINDI</h5>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Contact
